import { Suspense } from 'react';
import { Card } from 'react-bootstrap';

import { type DOI } from '../utils/doi';
import { Loading } from '../utils/Loading';
import { LoadReports } from './LoadReports';

export function DOIExperimentReportESRF({ doi }: { doi: DOI }) {
  return (
    <Suspense
      fallback={
        <Card.Body className="p-2">
          <Loading />
        </Card.Body>
      }
    >
      <LoadReports doi={doi} />
    </Suspense>
  );
}
